import { useTranslation } from 'react-i18next';
import { TermsEn } from './legal/TermsEn';
import { TermsRu } from './legal/TermsRu';

/**
 * Public terms of use (/terms). Two whole documents, like PrivacyPage:
 * legal/TermsRu.tsx is the original, legal/TermsEn.tsx its translation.
 */
export function TermsPage() {
  const { i18n } = useTranslation();
  return i18n.language.startsWith('en') ? <TermsEn /> : <TermsRu />;
}
